export default __webpack_public_path__ + "assets/china-flag.png";